module.exports = __webpack_public_path__ + "assets/img/2021-7.a36a514a.png";